import { render, staticRenderFns } from "./zjxq.vue?vue&type=template&id=20868694&scoped=true&"
import script from "./zjxq.vue?vue&type=script&lang=js&"
export * from "./zjxq.vue?vue&type=script&lang=js&"
import style0 from "./zjxq.vue?vue&type=style&index=0&id=20868694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20868694",
  null
  
)

component.options.__file = "zjxq.vue"
export default component.exports